import { atom } from 'recoil';

import { ICommand } from 'client-types/*';

export interface IAttachment {
  id: string;
  serverId?: string;
  name: string;
  size: number;
  type: string;
  uploadProgress?: number;
  uploaded?: boolean;
  cancel?: () => void;
  remove?: () => void;
}

export const attachmentsState = atom<IAttachment[]>({
  key: 'Attachments',
  default: []
});

export const persistentCommandState = atom<ICommand | undefined>({
  key: 'PersistentCommand',
  default: undefined
});

// Selected knowledge base ID ('none' = not using KB)
export const selectedKbIdState = atom<string>({
  key: 'SelectedKbId',
  default: 'none'
});

// Selected System Prompt ID ('default' = 不指定，後端依智慧載入決定)
export const selectedSystemPromptIdState = atom<string>({
  key: 'SelectedSystemPromptId',
  default: 'default'
});

// 快速模式開關（工具列）。每個分頁／對話視窗各自一份，隨訊息 metadata 送給後端，
// 伺服器不保存全域狀態，所以不同使用者、不同視窗互不影響。
// null = 尚未初始化（以 /api/config 的 fast_path_default 帶入）。
export const fastModeState = atom<boolean | null>({
  key: 'FastMode',
  default: null
});

// 歷史對話接續模式（/chat?conv=:id）：非 null 時 MessageComposer 會在
// metadata 帶上 conversation_id，讓後端 on_message 接續該對話
export const resumeConversationIdState = atom<string | null>({
  key: 'ResumeConversationId',
  default: null
});
